import { FC } from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import {
  BoxProps,
  FormControl,
  FormErrorMessage,
  Input,
  InputGroup,
  InputProps,
} from '@chakra-ui/react';
import { NumberFormatWrapper } from '../NumberFormatWrapper';
import { ConnectForm } from './ConnectForm';
import { FieldLabel, FieldLabelProps } from './FieldLabel';

interface ConnectedPhoneInputProps {
  containerProps?: BoxProps;
  labelProps?: FieldLabelProps;
  id: string;
  placeholder?: string;
  inputProps?: InputProps;
}

export const ConnectedPhoneInput: FC<ConnectedPhoneInputProps> = ({
  containerProps,
  labelProps,
  placeholder = 'Phone Number',
  inputProps,
  id,
}) => {
  return (
    <ConnectForm>
      {({ ...formMethods }: UseFormReturn) => (
        <FormControl
          {...containerProps}
          isInvalid={!!formMethods.formState.errors[id]}
        >
          {labelProps?.text && <FieldLabel {...labelProps} />}
          <InputGroup maxWidth="100%">
            <Controller
              render={({ field: { ...rest } }) => (
                <NumberFormatWrapper
                  format="+1 (###) ###-####"
                  mask="_"
                  placeholder={placeholder}
                  type="text"
                  id={id}
                  borderRadius="md"
                  fontSize="lg"
                  h={12}
                  px={4}
                  _placeholder={{ color: 'blackAlpha.500' }}
                  {...inputProps}
                  {...rest}
                  customInput={Input}
                />
              )}
              control={formMethods.control}
              name={id}
            />
          </InputGroup>
          {formMethods.formState.errors[id] ? (
            <FormErrorMessage ml={2}>
              {formMethods.formState.errors[id].message?.toString()}
            </FormErrorMessage>
          ) : null}
        </FormControl>
      )}
    </ConnectForm>
  );
};
